import React, { useEffect } from "react";

import { useNavigate } from "react-router-dom";

import { useAuthenticationContext } from "../context/authentication";
import { ROUTES } from "../routes";

import { ACKNOWLEDGEMENT_OF_COUNTRY_MODAL } from "./public/AcknowledgementOfCountryModal";

const clearRequiredItemsFromLocalStorage = () => {
  // If the acknowledgement of country modal has been viewed in this browser ever before, we need to preserve that value in local storage, so that it is not shown again to any user (returning or new) viewing it on same browser.
  const hasSeenAcknowledgementOfCountryModal = localStorage.getItem(ACKNOWLEDGEMENT_OF_COUNTRY_MODAL.key);

  localStorage.clear();

  if (hasSeenAcknowledgementOfCountryModal === ACKNOWLEDGEMENT_OF_COUNTRY_MODAL.value) {
    localStorage.setItem(ACKNOWLEDGEMENT_OF_COUNTRY_MODAL.key, ACKNOWLEDGEMENT_OF_COUNTRY_MODAL.value);
  }
};

export const SignOut = () => {
  const { auth, signOut } = useAuthenticationContext();
  const navigate = useNavigate();

  useEffect(() => {
    if (auth) {
      signOut();
      // TODO: [NRRS-577] Also clear if a guest accesses the page
      // - e.g. if login session expires/timesout and guest reaches the page

      clearRequiredItemsFromLocalStorage();
      sessionStorage.clear();
      window.location.reload();
    } else {
      navigate(ROUTES.Root.path);
    }
  }, [auth, navigate, signOut]);

  return <></>;
};
